import { motion } from "framer-motion";

const ASSET_ALLOCATION = [
  { type: "Cổ phiếu", value: "18%", width: "89%", color: "#b9a2fb" },
  { type: "Vàng", value: "15%", width: "76%", color: "#fccc50" },
  { type: "Trái phiếu", value: "12%", width: "63%", color: "#3389f0" },
  { type: "Crypto", value: "8%", width: "44%", color: "#f09933" },
];

const AssetsStepBody = () => (
  <div className="w-full max-w-[462px] mx-auto space-y-[12px]">
    {ASSET_ALLOCATION.map((asset, idx) => (
      <div key={idx} className="flex items-center h-[24px]">
        <div className="flex items-center gap-[4px] w-[139px] shrink-0">
          <span className="px-[6px] py-[2px] bg-[#ececed] rounded-[16px] text-[10px] font-medium text-[#636369]">
            {asset.type}
          </span>
        </div>

        <div className="flex-1 max-w-[256px] h-[8px] bg-[#FFFFFF] rounded-[4px] overflow-hidden shadow-[0_0_20px_0_#0000000D]">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: asset.width }}
            transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="h-full rounded-[4px]"
            style={{ backgroundColor: asset.color }}
          />
        </div>

        <span className="text-[16px] font-bold text-[#111827] w-[65px] text-right ml-auto">
          <div className="w-[40px] h-[24px] bg-[#3c3c430d] rounded-[6px] ml-auto" />
        </span>
      </div>
    ))}

    {Array(2).map((_, idx) => (
      <div key={`skeleton-${idx}`} className="flex items-center h-[24px]">
        <div className="flex items-center gap-[4px] w-[139px] shrink-0">
          <div className="w-[40px] h-[20px] bg-[#3c3c430d] rounded-[10px]" />
        </div>
        <div className="flex-1 max-w-[256px] h-[8px] bg-[#ececed] rounded-[4px]" />
        <div className="w-[40px] h-[24px] bg-[#3c3c430d] rounded-[6px] ml-auto" />
      </div>
    ))}
  </div>
);

export default AssetsStepBody;
